<template>
  <form @submit.prevent>
    <div>
      <label for="name">Name</label>
      <input
        v-model.trim="createUserForm.name"
        type="text"
        placeholder="Full Name"
        id="name"
      />
    </div>
    <div>
      <label for="title">Title</label>
      <input
        v-model.trim="createUserForm.title"
        type="text"
        placeholder="Title"
        id="title"
      />
    </div>
    <div>
      <label for="email2">Email</label>
      <input
        v-model.trim="createUserForm.email"
        type="text"
        placeholder="you@email.com"
        id="email2"
      />
    </div>
    <div></div>
    <button @click="createUser()" class="button">Create User</button>
  </form>
</template>

<script>
import { bus } from "../main";
export default {
  data() {
    return {
      createUserForm: {
        name: "",
        title: "",
        email: "",
      },
    };
  },
  methods: {
    createUser() {
      this.$store.dispatch("createUser", this.createUserForm);
      bus.$emit("closeModal");
      this.createUserForm = {
        name: "",
        title: "",
        email: "",
      };
    },
  },
};
</script>
